import React, { FC } from 'react';
import { InteractionDimension, JourneyFilterState } from '../../../../models/journey-explorer/journey-explorer';
import { COLORS, selectedDimensionValues, toggleDimensionValue } from '../journey-explorer-utils';
import { DimensionOptions, FilterGroup } from './filter-group';

export const DETAIL_GROUP_LABEL = 'Interaction Filters';

interface InteractionDetailGroupProps {
	dimensions: InteractionDimension[];
	filterState: JourneyFilterState;
	open: boolean;
	search?: string;
	onToggle: () => void;
	onChange: (state: JourneyFilterState) => void;
}

const InteractionDetailGroup: FC<InteractionDetailGroupProps> = ({
	dimensions,
	filterState,
	open,
	search,
	onToggle,
	onChange,
}) => {
	const count = filterState.dimension_filters.reduce((total, filter) => total + filter.values.length, 0);

	return (
		<FilterGroup
			label={DETAIL_GROUP_LABEL}
			color={COLORS.interaction}
			count={count}
			open={open}
			search={search}
			onToggle={onToggle}
		>
			{dimensions.map((dimension) => (
				<DimensionOptions
					key={`${dimension.table}.${dimension.column}`}
					label={dimension.label}
					values={dimension.values}
					selected={selectedDimensionValues(filterState, dimension.table, dimension.column)}
					color={COLORS.interaction}
					search={search}
					onToggle={(value) =>
						onChange(toggleDimensionValue(filterState, dimension.table, dimension.column, value))
					}
				/>
			))}
		</FilterGroup>
	);
};

export default InteractionDetailGroup;
